<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<h2 class="heading"><span class="smallcaps">ALSO BY <br/></span>ELENA FERRANTE</h2>
<p class="center"><em class="italic">The Days of Abandonment</em></p>
<p class="center"><em class="italic">Troubling Love</em></p>
<p class="center"><em class="italic">The Lost Daughter</em></p>
<p class="center"><em class="italic">The Beach at Night</em></p>
<p class="center"><em class="italic">Frantumaglia: A Writer’s Journey </em></p>
<p class="center"><em class="italic">Incidental Inventions</em></p>
<p class="center"> </p>
<p class="center">M<span class="smallcaps">Y </span>B<span class="smallcaps">RILLIANT </span>F<span class="smallcaps">RIEND</span></p>
<p class="center">(The Neapolitan Quartet)</p>
<p class="center"> </p>
<p class="center"><em class="italic">My Brilliant Friend</em></p>
<p class="center"><em class="italic">The Story of a New Name</em></p>
<p class="center"><em class="italic">Those Who Leave and Those Who Stay </em></p>
<p class="center"><em class="italic">The Story of the Lost Child</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// lying-life.vue?42625d40